const MONEY_FORMATTER = new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD", maximumFractionDigits: 0 });

export const currency = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return MONEY_FORMATTER.format(n);
};

export const shortDate = (value) => {
  if (!value) return "n/a";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "n/a" : d.toLocaleDateString();
};

export const hasKnownMoneyValue = (value) => {
  if (value === null || value === undefined || value === "") return false;
  return Number.isFinite(Number(value));
};

export const moneyValueLabel = (value) => (hasKnownMoneyValue(value) ? currency(value) : "No Value Set");
